export const UI_BACKGROUNDCOLOR = '#f6f6f6';
export const TOOLBAR_HEIGHT = 64;
